function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m7.4477 9.7915v13.458h6.0917v-18.438z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m7.4477 9.7915v13.458h6.0917v-18.438z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m35.365 9.8738v13.54h-6.0917v-18.603z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(2.9162)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
}, React.createElement("path", {
  d: "m28.498 9.1155v2.7456"
}), React.createElement("path", {
  d: "m28.498 14.207v2.6399"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m32.239 23.414-2.9655 4e-6v-18.603l3.0633 2.72",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 7.6,
  strokeWidth: 0.8
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m17.326 0.53134v1.8109h7.7381v-1.8109z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m17.467 0.53134h7.9143v1.8109h-7.9143z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m15.455 1.5312v1.3765h11.914v-1.3765z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m15.42 1.5312h12.09v2.2926h-12.09z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-secondary",
  d: "m22.971 15.224v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.7741v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.6507v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm-3.0859-2.7986h16.064v20.414h-6.2141v-3.416h-3.6355v3.416h-6.2141z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m22.971 15.224v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.7741v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm6.51-4.6507v2.6752h3.4241v-2.6752zm-6.51 0v2.6752h3.4241v-2.6752zm-3.0859-2.7986h16.064v20.414h-6.2141v-3.416h-3.6355v3.416h-6.2141z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m6.5024 18.64 0.12115 0.20578c1.2519 1.2758 2.9479 2.0578 4.8459 2.0578 1.9384 0 3.6344-0.78197 4.8863-2.0578l0.12115-0.20578 1.0096 0.24694c2.9479 1.2347 4.9671 4.1568 4.9671 7.6139v6.9143l-3.5537 1.317c-2.3826 0.57619-4.8863 0.86428-7.4304 0.86428-2.5037 0-5.0075-0.2881-7.39-0.86428l-3.5941-1.317v-6.9143c0-3.4571 2.0595-6.3792 5.0075-7.6139z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.0075 0 0 1.0268 -2.0184 -.044853)",
  d: "m8.4571 18.197 0.12024 0.2004c1.2425 1.2425 2.9259 2.004 4.8097 2.004 1.9239 0 3.6073-0.76154 4.8498-2.004l0.12024-0.2004 1.002 0.24048c2.9259 1.2024 4.93 4.0482 4.93 7.415v6.7336l-3.5271 1.2826c-2.3648 0.56113-4.8498 0.8417-7.3749 0.8417-2.485 0-4.97-0.28057-7.3348-0.8417l-3.5672-1.2826v-6.7336c0-3.3668 2.0441-6.2125 4.97-7.415z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.78652
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m4.6852 14.442c0-3.8275 3.1095-6.9966 6.8651-6.9966 3.796 0 6.8651 3.169 6.8651 6.9966 0 3.8687-3.0691 6.9966-6.8651 6.9966-3.7556 0-6.8651-3.1279-6.8651-6.9966z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m4.6852 14.442c0-3.8275 3.1095-6.9966 6.8651-6.9966 3.796 0 6.8651 3.169 6.8651 6.9966 0 3.8687-3.0691 6.9966-6.8651 6.9966-3.7556 0-6.8651-3.1279-6.8651-6.9966",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.8
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m35.443 4.4823h18.533l5.5721 5.591v23.453h-24.105z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.2089 0 0 1.2077 .55678 -5.4169)",
  d: "m28.858 8.1966h15.331l4.6093 4.6293v19.419h-19.94z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.66209
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m59.524 10.001h-5.5721v-5.5668z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m59.524 10.001h-5.5721v-5.5668z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "m48.268 21.015v3.5925c0.60788-0.13997 1.0755-0.37325 1.4028-0.69984 0.28056-0.32659 0.42084-0.69984 0.42084-1.1198 0-0.32659-0.09352-0.65319-0.37408-0.97978-0.2338-0.27994-0.74815-0.55988-1.4495-0.79316zm-1.6833-7.465c-0.4676 0.13997-0.79492 0.3266-0.98195 0.55988-0.18704 0.23328-0.28056 0.51322-0.28056 0.83981 0 0.3266 0.09352 0.60653 0.28056 0.83982 0.18704 0.27994 0.51436 0.46656 0.98195 0.65319zm0-4.0591h1.6833v1.1198c1.6833 0.13997 2.9459 0.51322 3.8343 1.2131 0.93519 0.69984 1.4963 1.633 1.7769 2.846l-4.2084 0.65319c-0.2338-0.55988-0.42084-0.88647-0.56112-1.1198-0.18704-0.18662-0.4676-0.41991-0.84167-0.60653v3.2659c2.2912 0.60653 3.7875 1.2131 4.5824 1.9129 1.0287 0.88647 1.4963 2.0529 1.4963 3.4526 0 0.79316-0.14028 1.5397-0.51436 2.2395-0.37408 0.69985-0.84167 1.2597-1.4028 1.7263-0.56112 0.46656-1.169 0.79316-1.8236 0.97978-0.65464 0.23328-1.4028 0.32659-2.338 0.37325v2.0995h-1.6833v-2.0995c-1.0755-0.09331-2.0107-0.27994-2.6653-0.51322-0.7014-0.27994-1.3093-0.65319-1.8236-1.1198-0.4676-0.41991-0.88843-0.93313-1.1222-1.4463-0.28056-0.55988-0.51436-1.1664-0.65464-1.9129l4.5824-0.55988c0.14028 0.7465 0.32732 1.3064 0.56112 1.633s0.60788 0.60653 1.1222 0.88647v-4.0124c-1.4963-0.41991-2.5718-0.7465-3.2264-1.0731-0.65464-0.3266-1.169-0.79316-1.6366-1.493-0.4676-0.65319-0.7014-1.493-0.7014-2.4728 0-1.353 0.4676-2.4261 1.4028-3.3593 0.93519-0.88647 2.338-1.3997 4.1616-1.493z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m48.268 21.015v3.5925c0.60788-0.13997 1.0755-0.37325 1.4028-0.69984 0.28056-0.32659 0.42084-0.69984 0.42084-1.1198 0-0.32659-0.09352-0.65319-0.37408-0.97978-0.2338-0.27994-0.74815-0.55988-1.4495-0.79316zm-1.6833-7.465c-0.4676 0.13997-0.79492 0.3266-0.98195 0.55988-0.18704 0.23328-0.28056 0.51322-0.28056 0.83981 0 0.3266 0.09352 0.60653 0.28056 0.83982 0.18704 0.27994 0.51436 0.46656 0.98195 0.65319zm0-4.0591h1.6833v1.1198c1.6833 0.13997 2.9459 0.51322 3.8343 1.2131 0.93519 0.69984 1.4963 1.633 1.7769 2.846l-4.2084 0.65319c-0.2338-0.55988-0.42084-0.88647-0.56112-1.1198-0.18704-0.18662-0.4676-0.41991-0.84167-0.60653v3.2659c2.2912 0.60653 3.7875 1.2131 4.5824 1.9129 1.0287 0.88647 1.4963 2.0529 1.4963 3.4526 0 0.79316-0.14028 1.5397-0.51436 2.2395-0.37408 0.69985-0.84167 1.2597-1.4028 1.7263-0.56112 0.46656-1.169 0.79316-1.8236 0.97978-0.65464 0.23328-1.4028 0.32659-2.338 0.37325v2.0995h-1.6833v-2.0995c-1.0755-0.09331-2.0107-0.27994-2.6653-0.51322-0.7014-0.27994-1.3093-0.65319-1.8236-1.1198-0.4676-0.41991-0.88843-0.93313-1.1222-1.4463-0.28056-0.55988-0.51436-1.1664-0.65464-1.9129l4.5824-0.55988c0.14028 0.7465 0.32732 1.3064 0.56112 1.633s0.60788 0.60653 1.1222 0.88647v-4.0124c-1.4963-0.41991-2.5718-0.7465-3.2264-1.0731-0.65464-0.3266-1.169-0.79316-1.6366-1.493-0.4676-0.65319-0.7014-1.493-0.7014-2.4728 0-1.353 0.4676-2.4261 1.4028-3.3593 0.93519-0.88647 2.338-1.3997 4.1616-1.493z",
  fill: "none",
  stroke: "#002060",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var SvgMenuClientInvoice = function SvgMenuClientInvoice(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuClientInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-Client-Invoice.bb6732ed.svg";
export { ForwardRef as ReactComponent };